// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"675":"67dbf9b5","2706":"67dbf9b5","3091":"67dbf9b5","5472":"67dbf9b5","8153":"67dbf9b5"}[chunkId] + ".chunk.css";
};